import React from 'react';

import { getDateFromTimeInSec, parsePrice } from '../../../../utils/utils';

const VehicleNum = (props: any) => (
  <div className="data-column small">
    <p>{props.vehicleNumber}</p>
  </div>
);

const TxnId = (props: any) => (
  <div className="data-column small">
    <p>{props.txnId}</p>
    {props.ticket ? <p>{`${props.ticket} Open Ticket`}</p> : null}
  </div>
);

const TxnToll = (props: any) => (
  <div className="data-column small">
    <p>{props.plaza || '---'}</p>
    <p className="date mt8">{getDateFromTimeInSec(props.time)}</p>
  </div>
);

const TxnType = (props: any) => (
  <div className="data-column small">
    <p>{props.type ? `${props.type}` : '---'}</p>
  </div>
);

const TxnAmount = (props: any) => (
  <div className="data-column small flex">
    <p>{parsePrice({ price: props.amount })}</p>
  </div>
);

const TxnOpenAmount = (props: any) => (
  <div className="data-column small flex">
    <p>{parsePrice({ price: props.openingBalance })}</p>
  </div>
);

const TxnCloseAmount = (props: any) => (
  <div className="data-column small flex">
    <p>{parsePrice({ price: props.closingBalance })}</p>
  </div>
);

interface headingObj {
  heading?: string;
}

export const dataMapping = (headingProps: headingObj) => [
  {
    name: VehicleNum,
    attr: ['vehicleNumber'],
    heading: 'Vehicle No.',
  },
  {
    name: TxnId,
    attr: ['txnId'],
    heading: 'Transaction Id',
  },
  {
    name: TxnToll,
    attr: ['plaza', 'time'],
    heading: 'Transaction',
  },
  {
    name: TxnType,
    attr: ['type'],
    heading: 'Type',
  },
  {
    name: TxnAmount,
    attr: ['amount'],
    heading: 'Amount',
  },
  {
    name: TxnOpenAmount,
    attr: ['openingBalance'],
    heading: 'Opening Bal.',
  },
  {
    name: TxnCloseAmount,
    attr: ['closingBalance'],
    heading: 'Closing Bal.',
  },
];
